import { forwardRef, InputHTMLAttributes, ReactNode } from 'react';
import cx from 'clsx';
import styles from './TextField.module.css';
import { Error, Input, Label } from './views';

export interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string | ReactNode;
  fullWidth?: boolean;
  error?: string | ReactNode;
}

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  (props, ref) => {
    const {
      label,
      fullWidth,
      children,
      error,
      id = `text-field-${props.name}`,
      ...inputProps
    } = props;

    return (
      <div>
        <div
          className={cx(styles.textField, {
            [styles.fullWidth]: fullWidth,
            [styles.disabled]: inputProps.disabled,
          })}
        >
          <Input
            ref={ref}
            type="text"
            id={id}
            error={!!error}
            {...inputProps}
          />
          {label && (
            <Label
              htmlFor={id}
              focused={props.value !== '' && props.value != null}
            >
              {label}
            </Label>
          )}
          {children}
        </div>
        {error && <Error>{error}</Error>}
      </div>
    );
  }
);
